import { Component } from '@angular/core';
import { SpinnerService } from '../../Services/spinner.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-spinner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.css',
})
export class SpinnerComponent {
  loading$ = this.spinnerService.loading$;

  constructor(private spinnerService: SpinnerService) {}
}
